import { createAsyncThunk } from "@reduxjs/toolkit";
import referralApi from 'api/referralApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getReferralTriggerEvents = createAsyncThunk("TriggerEvents", async (params: any = {}) => {
  try {
    const response = await referralApi.triggerEvents(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const postReferralTriggerEvent = async (data: any = {}) => {
  try {
    const response = await referralApi.postTriggerEvent(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putReferralTriggerEvent = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.putTriggerEvent(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteReferralTriggerEvent = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.deleteTriggerEvent(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
